export const PIN_DATE = {
  year: 1970,
  month: 0,
  date: 1,
} as const;

export const ROWS = 5;
